<app-header></app-header>

<section class="container-xxl">
    <!-- BREADCRUMB AREA - STARTS -->
    <div class="breadcrumb-area">
        <app-plugin-breadcrumb [datacollection]="{data:P_data,'showEmpMen':showEmpMen,'emp_dtl':emp_dtl}" *ngIf="showBarComponent"></app-plugin-breadcrumb>
    </div> 
    <!-- BREADCRUMB AREA - ENDS -->
  
    <div class="inner-page"> 
        <div class="inner-page-details">
            <div class="row"> 
                <div [ngClass]="navMenu ? 'col-xl-3 col-xxl-2' : ''" *ngIf="navMenu">
                    <div [style]="navmenuloadCss">
                        <app-plugin-navbar [datacollection]="{data:P_data}" *ngIf="showNavComponent"></app-plugin-navbar>
                      </div>
                </div>
                <div [ngClass]="navMenu ? 'col-xl-9 col-xxl-10' : 'col-lg-12'">
                    <!-- INNER CONTENT - STARTS -->
                    <div class="inner-page-sidedetails">
                        <div class="row">
                            <div class="col-lg-12">
                                <div id="section-New"></div>
                                <div class="inner-banner-image">
                                    <div class="image-area">
                                        <img class="screen-reader" src="assets/images/inner-banner-2.webp" alt="inner-banner-image">
                                    </div>
                                </div>
                                <div class="details">
                                    <div class="title d-flex justify-content-between">
                                       <h2 class="screen-reader">{{'Circulars' | translate}}</h2>
                                        <a [attr.title]="language=='English'?'Archive Circular':'परिपत्र संग्रहित करें'" routerLink="/archivecircular" class="btn btn-sm btn-outline-success screen-reader"><i class="bi bi-archive me-2"></i>{{'ArchiveCircular' | translate}}</a>
                                    </div>
<div class="description">
<div class="circulars">
<div class="row">
<div class="col-lg-12">
    <!-- search section -->
    <div class="searchpanel notific-frm" >
 
        <form [formGroup]="searchForm" (ngSubmit)="searchCircularList()"  *ngIf="issearch == true || isdisplay == true">
            <div class="row">
                <div class="col-xxl-3 col-xl-3 col-md-6 col-sm-6 col-xs-12">
                    <div class="form-group font-adjust">
                        <label class="mb-2 mt-2 screen-reader"> <b>{{'CircularNo' | translate}} </b> </label>
                        <input type="text" autocomplete="off"
                            class="form-control screen-reader" placeholder="{{'CircularNo' | translate}}" name="CircularNo" id="CircularNo" formControlName="CircularNo">
                    </div>
                </div>
                <div class="col-xxl-3 col-xl-3 col-md-6 col-sm-6 col-xs-12">
                    <div class="form-group font-adjust">
                        <label class="mb-2 mt-2 screen-reader"> <b>  {{'Title' | translate}} </b> </label>
                        <input type="text" autocomplete="off"
                            class="form-control screen-reader" placeholder="{{'Title' | translate}}" name="title" id="title" formControlName="title">
                    </div>
                </div>
                <div class="col-xxl-3 col-xl-3 col-md-6 col-sm-6 col-xs-12">
                    <div class="form-group font-adjust"> 
                        <label class="mb-2 mt-2 screen-reader"> <b>  {{'Division' | translate}} </b> </label>
                        
                            <select class="form-select screen-reader" name="division" id="division" formControlName="division">
                            <option value="" selected>--{{'Division' | translate}}--</option>
                            <option *ngFor="let item of circularDiv" value="{{item.id}}" >{{htmldecode(language == 'English' ? item.name: item.nameInHindi)}}</option>
                        
                        </select>

                    </div>
                </div>
                <div class="col-xxl-3 col-xl-3 col-md-6 col-sm-6 col-xs-12">
                    <div class="form-group font-adjust">
                        <label class="mb-2 mt-2 screen-reader"> <b>{{'IssueDateFrom' | translate}}</b></label>
                        <input type="date" autocomplete="off"
                            class="form-control screen-reader" placeholder="{{'IssueDateFrom' | translate}}" name="from_date" id="from_date" formControlName="from_date">
        
                    </div>
                </div>
                <div class="col-xxl-3 col-xl-3 col-md-6 col-sm-6 col-xs-12">
                    <div class="form-group font-adjust">
                        <label class="mb-2 mt-2 screen-reader"> <b> {{'IssueDateTo' | translate}}</b> </label>
                        <input type="date" autocomplete="off"
                            class="form-control screen-reader" placeholder="{{'IssueDateTo' | translate}}" name="to_date" id="to_date" formControlName="to_date">
        
                    </div>
                </div>
                <div class="col-xxl-3 col-xl-3 col-md-6 col-sm-6 col-xs-12 d-flex align-items-end">
                    <div class="d-flex align-items-center gap-3 mt-3">
                        
                        <button type="submit" [attr.title]="language=='English'?'Search':'खोजें'" class="btn btn-outline-success screen-reader" [disabled]="ifdisabled" [innerHTML]="btncontent"> 
                        </button>
                        <div *ngIf="RefreshBtn">
                            <button type="button" [attr.title]="language=='English'?'Refresh':'रीफ़्रेश करें'" class="btn btn-outline-secondary py-0-2 screen-reader" (click)="RefreshPage()"> 
                                <i class="bi bi-arrow-repeat fs-5" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div> 

    <!-- search section-->
        
    <!-- circular section area -->
    <ng-container  *ngIf="circularList && circularList.length > 0; else noDataTemplate" >
    <div class="d-flex justify-content-start flex-wrap circular-box-area" *ngFor="let item of circularList | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: totalRecords}; let i = index;">
        <div class="circular-count">
            <div class="count-box d-flex justify-content-center align-items-center ">
                <h2 class="screen-reader" *ngIf="currentPage==1"> {{ i+1 }} </h2> 
                <h2 class="screen-reader" *ngIf="currentPage>1"> {{(limit*(currentPage-1)) + (i+1)}} </h2> 
            </div>
        </div>
        <div class="circular-details">
            <div class="circular-txt">
                <h4 class="screen-reader font-adjust">

                    {{ item.VCH_CIRCULAR_ID!==''?
                    language=='English'?'Circular No. '+item.VCH_CIRCULAR_ID+", ":'परिपत्र संख्या '+item.VCH_CIRCULAR_ID+", "
                    :'' }} 
                    {{ htmlTag(language == 'English' ? item.VCHTITLE: item.VCHTITLE_HINDI)}}
                </h4>
            </div>
            <div class="note-dates d-sm-flex justify-content-between align-items-center  font-adjust">
                <div 
                    class="d-flex align-items-center flex-wrap">
                    <div class="opening-date screen-reader">
                        <strong class="d-block text-green">
                            <span class="me-2"> <i class="bi bi-building me-1"></i>
            {{ getDivisionName(item.INTCIRCULARDIV)=="" || getDivisionName(item.INTCIRCULARDIV)==undefined?jsonConvert(item,'INTCIRCULARDIV'):getDivisionName(item.INTCIRCULARDIV) }} 
                            </span>
                        </strong>
                        <div class="text-muted">{{'Division' | translate}} </div>
                    </div>

                    <div class="opening-date screen-reader">
                        <strong class="d-block text-red">
                            <span class="me-2"> 
                                <i class="bi bi-calendar3 me-1"></i>
                                {{ item.VCHPUBLISH_DATE }}
                            </span>
                        </strong>
                        <div class="text-muted">{{'DateOfIssue' | translate}} </div>
                    </div>
                </div> 
                <div class="d-flex mt-2">
                <a href="javascript:void(0)" (click)="viewDetails(item.intId,'circulardetails')"  [attr.title]="language=='English'?'Click here go to the Circular Details':'यहां क्लिक करें परिपत्र विवरण पर जाएं'"
                    class="btn btn-outline-success me-1 screen-reader">
                    <i class="bi-eye"></i>
                    {{'Details' | translate}}
                </a>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #noDataTemplate>

    <p class="screen-reader font-adjust" [style.text-align]="'center'"><b>{{ "Norecordsfound" | translate }}</b></p>
  </ng-template>
    
    <!-- circular section area -->

    <div class="my-4">
        

        <pagination-controls class="text-center screen-reader" (pageChange)="pageChanged($event)" *ngIf="totalRecords > limit"></pagination-controls>
</div>
</div>
</div>
</div>
</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- INNER CONTENT - ENDS -->
                </div>
            </div>
        </div>
    </div>

</section>

<app-clients></app-clients>

<app-footer></app-footer>